import { render, staticRenderFns } from "./ProduceList.vue?vue&type=template&id=56c1a275&"
import script from "./ProduceList.vue?vue&type=script&lang=js&"
export * from "./ProduceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports